import React from 'react';
import {
  Box,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Package, Info } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { useOrganization } from '../../../hooks/useOrganization';
import { OrganizationInfo } from './components/OrganizationInfo';
import { OrganizationDeliveries } from './OrganizationDeliveries/OrganizationDeliveries';

// ?tab=organisaatio            → index 0 (Tiedot)
// ?tab=organisaatio&kuljetukset → index 1 (Toimitukset)
const DELIVERIES_PARAM = 'kuljetukset';

export const OrganizationSection = ({ user, userData }) => {
  const theme    = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [searchParams, setSearchParams] = useSearchParams();
  const deliveriesActive = searchParams.has(DELIVERIES_PARAM);
  const activeTab = deliveriesActive ? 1 : 0;

  const setTab = (index) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (index === 1) {
        next.set(DELIVERIES_PARAM, '');
      } else {
        next.delete(DELIVERIES_PARAM);
      }
      return next;
    }, { replace: true });
  };

  const {
    organizationData,
    loading: orgLoading,
    updateOrganization,
    createOrganization,
    addMember,
    removeMember,
    updateMember,
    isOwner,
    isMember,
    hasOrganization,
    organizationId,
    getMemberCount,
    getMembers,
  } = useOrganization(userData?.organizationId, user?.uid, userData);

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(_, v) => setTab(v)}
        variant={isMobile ? 'fullWidth' : 'standard'}
        sx={{ borderBottom: 1, borderColor: 'divider', px: { xs: 0, sm: 2 } }}
      >
        <Tab
          icon={<Info size={18} />}
          iconPosition="start"
          label="Tiedot"
          sx={{ minHeight: { xs: 48, sm: 64 }, fontSize: { xs: '0.875rem', sm: '1rem' } }}
        />
        {hasOrganization && (
          <Tab
            icon={<Package size={18} />}
            iconPosition="start"
            label="Toimitukset"
            sx={{ minHeight: { xs: 48, sm: 64 }, fontSize: { xs: '0.875rem', sm: '1rem' } }}
          />
        )}
      </Tabs>

      <Box role="tabpanel" hidden={activeTab !== 0}>
        {activeTab === 0 && (
          <OrganizationInfo
            user={user}
            userData={userData}
            organizationData={organizationData}
            loading={orgLoading}
            updateOrganization={updateOrganization}
            createOrganization={createOrganization}
            addMember={addMember}
            removeMember={removeMember}
            updateMember={updateMember}
            isOwner={isOwner}
            isMember={isMember}
            hasOrganization={hasOrganization}
            organizationId={organizationId}
            getMemberCount={getMemberCount}
            getMembers={getMembers}
          />
        )}
      </Box>

      {hasOrganization && (
        <Box role="tabpanel" hidden={activeTab !== 1}>
          {activeTab === 1 && (
            <OrganizationDeliveries
              organizationId={organizationId}
              user={user}
              isMember={isMember}
              isOwner={isOwner}
            />
          )}
        </Box>
      )}
    </Box>
  );
};